import React, { FC, memo } from 'react'
import Box from 'transfix-ui/core/Box'
import { Stop } from 'apps/fleet-planner/types'
import { brandColors } from 'transfix-ui'
import { StopSummaryItem } from './StopsSummaryItem'

interface IStopsSummaryProps {
  stops: Stop[]
}

const StopsSymbolConnector: FC = () => {
  return (
    <Box
      height='40px'
      bgcolor={brandColors.coolGray4}
      width='2px'
      marginTop='-28px'
      marginBottom='-12px'
      marginX='3px'
    />
  )
}

export const StopsSummary = memo<IStopsSummaryProps>(({ stops }) => {
  return (
    <>
      {stops.map((stop, idx) => {
        const isLastStop = idx === stops.length - 1
        return (
          <div key={stop.id}>
            <StopSummaryItem stop={stop} isLastStop={isLastStop} />
            {!isLastStop && <StopsSymbolConnector />}
          </div>
        )
      })}
    </>
  )
})
